import React, { useState } from 'react';
import type { InventoryItem } from '../../types';

interface AdjustStockModalProps {
  item: InventoryItem;
  onClose: () => void;
  onAdjust: (itemId: number, adjustment: number) => void;
}

const AdjustStockModal: React.FC<AdjustStockModalProps> = ({ item, onClose, onAdjust }) => {
  const [adjustment, setAdjustment] = useState(0);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (adjustment === 0) {
        onClose();
        return;
    }
    onAdjust(item.id, adjustment);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
      <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-md">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Adjust Stock</h2>
        <p className="mb-2">Item: <span className="font-semibold">{item.name}</span></p>
        <p className="mb-6">Current Stock: <span className="font-semibold">{item.stock} {item.unit}</span></p>
        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label htmlFor="adjustment" className="block text-sm font-medium text-gray-700 mb-1">
              Adjustment (use negative to decrease)
            </label>
            <input 
              type="number" 
              name="adjustment" 
              id="adjustment" 
              value={adjustment}
              onChange={(e) => setAdjustment(parseInt(e.target.value, 10) || 0)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-100 text-gray-900 focus:outline-none focus:ring-pink-500 focus:border-pink-500"
              autoFocus
            />
          </div>
          <div className="flex justify-end space-x-4">
            <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300">Cancel</button>
            <button type="submit" className="px-4 py-2 bg-pink-500 text-white rounded-md hover:bg-pink-600">Apply Adjustment</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdjustStockModal;